
<template>
<div class="pt-0 ptHeader mainBackVaillant widthFull ">
  <loading v-if="loadingState || loadingState2" />
  <div class="container ">

    <!--   HEADER TITLE    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <div class="row justify-content-center text-left vaillantCont mt-5">
      <div class="col-md-12 pt-5 pb-5">

        Gentile Professionista,
        <br/><br/>
        Recentemente è stato pubblicato in Gazzetta Ufficiale il Decreto Legge n. 50/2022 recante "Misure
        urgenti in materia di politiche energetiche nazionali, produttività delle imprese e attrazione degli
        investimenti, nonché in materia di politiche sociali e di crisi Ucraina".
        <br/><br/>
        Le ultime disposizioni inserite nel testo di Legge prevedono un sostanziale cambiamento delle
        normative sui trasferimenti dei crediti dei Bonus edilizi, una variazione che interessa direttamente le
        imprese oltre ad istituti bancari ed enti di credito, i quali dovranno recepire ed allinearsi alle nuove
        disposizioni.
        <br/><br/>
        Per tali ragioni esterne sopra menzionate purtroppo indipendenti dalla nostra volontà, ci vediamo
        costretti a sospendere temporaneamente i servizi di cessione del credito erogati nella piattaforma
        <template v-if="brand == 'CHEBONUS'">
          <b class="green">  CheBonus (www.chebonus.it)  </b>
        </template>
        <template v-else>
          <b class="red"> HappyBonus (www.happybonus.it)  </b>

        </template>


        sino a quando non si saranno ripristinate le condizioni per poter
        ripartire e garantire stabilità e continuità al servizio per i nostri clienti professionisti e privati.
        <br/><br/>
        Il flusso relativo ad Agile Energy sarà anch’esso temporaneamente sospeso, fermo restando che le
        Pratiche già approvate verranno regolarmente evase alle condizioni preventivamente concordate.
        <br/><br/>
        Per ogni informazione, richiesta o supporto dedicato non esitare a contattarci al numero
        tel.
        <template v-if="brand == 'CHEBONUS'">
          <b class="green">  02.94756.677 </b>
        </template>
        <template v-else>
          <b class="red"> 02.94751.001 </b>

        </template>
        , sempre disponibili dal lunedì al venerdì negli orari 09:00-13:00 e 14:00-18:00,
        oppure inviaci una mail a
        <template v-if="brand == 'CHEBONUS'">
          <b class="green">  <a class="green" href="mailto:info@chebonus.it" target="_blank"> info@chebonus.it </a> </b>
        </template>
        <template v-else>
          <b class="green">   <a href="info@happybonus.it" class="red" target="_blank"> info@happybonus.it </a> </b>
        </template>

        <br/><br/>
        Ringraziandoti per aver scelto di installare i nostri prodotti ed in attesa di ripristino del programma
        ufficiale di sconto in fattura e cessione del credito
        <template v-if="brand == 'CHEBONUS'">
          <b class="green"> CheBonus, Vaillant  </b>
        </template>
        <template v-else>
          <b class="red"> HappyBonus, Hermann Saunier Duval  </b>

        </template>


        ti augura Buon lavoro.
        <br/><br/>
        Il tuo team
        <template v-if="brand == 'CHEBONUS'">
          <b class="green"> Vaillant CheBonus </b>
        </template>
        <template v-else>
          <b class="red">  Hermann Saunier Duval HappyBonus </b>
        </template>

        <br/><br/>
        <small>
          Questa comunicazione è strettamente confidenziale.
          <br/>E’ vietata qualsiasi divulgazione, riproduzione, distribuzione o uso del contenuto.
        </small>


      </div>
    </div>

  </div>

</div>

</div>


</div>
</template>

<script>
import {
  AUTH_REQUEST,
  AUTH_SOCIAL
} from 'actions/auth'

import {
  ADD_NOTIFICATIONS,
  GET_NOTIFICATIONS
} from 'actions/notifications'

import {
  mapGetters,
  mapState
} from 'vuex'
import axios from 'axios'
const moment = require('moment')

const numeral = require('numeral')
//import numFormat from 'vue-filter-number-format';



import {
  FormWizard,
  TabContent
} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import Datepicker from 'vuejs-datepicker'
import {
  it
} from 'vuejs-datepicker/dist/locale'


import Flows from '../flowSettings/flows.vue'


export default {
  name: 'login',
  data() {
    return {
      username: '',
      documents: {},
      password: '',
      token: '',
      numeral: require('numeral'),
      proccess: 'START',
      loading: false,
      priceAcc: '',
      brand: process.env.BRAND,
      flow: '',
      zeroEnea: false,
      zeroDcast: false,
      zeroAT: false,
      zeroOneri: false,
      zeroPratica: false,
      zeroVdC: false,
      zeroEneaOld: '',
      zeroDcastOld: '',
      zeroATOld: '',
      zeroOneriOld: '',
      zeroPraticaOld: '',
      zeroVdCOld: '',

      //NEWWWW 222
      client_owner_type: '',
      client_owner_codice_fiscale: '',

      client_codice_fiscale: '',
      client_partita_iva: '',

      priceWork: '',
      tempMail: '',
      socialEmail: false,
      social: '',
      items: {},
      ecoBonus: '',
      itemsAccessories: {},
      calcFinish: false,
      groups: {
        0: {
          name: 'Caldaia a condensazione',
          value: 'condensazione'
        },
        1: {
          name: 'Caldaia tradizionale',
          value: 'tradizionale'
        },
        2: {
          name: 'Pompa di calore',
          value: 'pompadicalore'
        },
        3: {
          name: 'Sistemi Ibridi kit completo',
          value: 'ibridi'
        },
        4: {
          name: 'Scaldacqua PDC',
          value: 'scaldacqua'
        },
        5: {
          name: 'Climatizzatore',
          value: 'climatizzatore'
        },
        6: {
          name: 'Collettore solare termico',
          value: 'solare'
        },
        7: {
          name: (process.env.BRAND == "CHEBONUS") ? 'Altro Prodotto Vaillant' : 'Altro Prodotto HSD',
          value: 'altroVaillant'
        },
      },
      groupsAccessori: {
        0: {
          name: 'Termoregolazione evoluta',
          value: 'termoregolazione'
        },
        1: {
          name: 'Altro Accessorio ' + (process.env.BRAND == "CHEBONUS" ? 'Vaillant' : 'HSD'),
          value: 'altroV'
        },
        2: {
          name: 'Valvole termostatiche',
          value: 'valvole_termostatiche'
        },
        3: {
          name: 'Altro materiale/valvolame',
          value: 'altro'
        },

      },
      groupsAccessoriDestination:{},
      confirmed: true,
      usoAbitativo: 1,
      resend_success: false,
      loadingState2: false,
      loadingState: false,
      passwordFieldType: 'password',
      moment: moment,
      productIndex: 0,
      accessoriesIndex: 0,
      calcInfo: {},
      products: [{
        index: 'product' + 0,
        indexCount: 'quantity' + 0,
        group: '',
        product: '',
        price: '',
        quantity: '',
        kw: '',
        error: false
      }],

      accessories: [
        {
        index: 'product' + 0,
        indexCount: 'quantity' + 0,
        group: '',
        product: '',
        price: '',
        quantity: '',
        kw: '',
        error: false
      }
    ],

      quantity: '',
      finish: process.env.FINISH,
      vw: window.innerWidth,
      stepSize: 'md',
      client_ragione_sociale:'',
      // TAB 1 CLIENT
      clientLastname: '',
      clientName: '',
      adress: '',
      civic: '',
      email: '',
      phone: '',
      mobile: '',
      provincies: [],
      province: '',
      provinciesState: true,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      cityError: false,
      zipError: false,
      city: '',
      zip: '',
      datiCatastali: '',

      // RESIDENCE
      client_province: '',
      client_city: '',
      client_zip: '',
      client_address: '',
      client_civic: '',

      client_mobile: '',
      client_phone: '',
      client_email: '',
      //TAB2 INTERVENTO
      eventType: '',
      eventStartdate: '',
      it: it,
      eventStartdate: '',
      disabledDatesStart: {
        to: '',
        from: ''
      },
      allProducts: {},
      totalAccessories: '0,00',
      totalProducts: '0,00',
      enea: '',
      requiredOperations: '',
      client_type: '',
      priceEnea: '',
      client_ownership: 'Proprietario',
      totalExtraMise: 0,
      clearExtraMise: false,
      NoEnea: false,
      priceDcast: '',
      priceAT: '0,00',

      iva_altri_oneri: 0.22,
      iva_accessori_lavoro: 0.10,
      iva_age_extra: 0.22,
      iva_age_lavoro: 0.10,
      iva_age_accessori: 0.10,

      age_lavoro: 0,
      age_extra: 0,

      bonusError: false,
      bonusErrorText: '',

      //new FLOW OLD RETURN
      dl: '0',

      tqsa: '10.000',
      edilLibera: '0', // 0 - unselected, 1 - yes, 2 - no
      showEdilLiberaSelect: false,

      iban_agileenergy: process.env.IBAN_AGILE_ENERGY,
      priceAgileenergy: 0,
      agileDiscount: process.env.AGILEENERGY_DISCOUNT,

    }

  },
  components: {
    FormWizard,
    TabContent,
    Datepicker,
    Flows,

  },
  methods: {



  },
  watch: {

  },
  created() {


  },
  mounted() {


  },
  computed: {
    ...mapGetters(['getNotifications', 'getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']),
    ...mapState({
      notifications: state => `${state.notifications}`,
    })
  },

}
</script>

<style scoped>
  .quardDescription.center.mb-0 {
    font-size: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/flowSettings/index.vue